// Import Packages
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';

// Import Recoil
import { personalizationState } from '../../../../../recoil-store/recoil-state';
import { useRecoilValue } from 'recoil';

// Import Icons
import DeleteIcon from '../../../../../../src/assets/icons/dasboardIcons/notification-delete-icon.svg';
import ReadIcon from '../../../../../../src/assets/icons/dasboardIcons/notification-read-icon.svg';
import UnreadIcon from '../../../../../../src/assets/icons/dasboardIcons/unread-icon.svg';

// Import Material UI
import { Button, Tooltip, withStyles } from '@material-ui/core';
import Popper from '@material-ui/core/Popper';
import Fade from '@material-ui/core/Fade';
import Paper from '@material-ui/core/Paper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { Close, Remove } from '@material-ui/icons';


// Import Pages
import NotificationService from '../../../../../services/NotificationService/NotificationService';
import FullScreenNotifications from './FullScreenNotifications';
import { CustomNotificationCheckbox } from '../../../../../components/FlowConfigurationInputs';
import NotificationsDetail from './NotificationsDetail';

// Import Helper
import { convertToDateFormat } from '../../../../../helpers/helper';


// const fetchNotifications = async () => {
//     const response = await NotificationService.getNotifications(true);
//     if (response.status) {
//         return response.data;
//     } else {
//         throw new Error('Failed to fetch notifications');
//     }
// };

const DashBoardNotifications = ({ open, anchorEl, handleClose, handleRead, label, handleDeleteNotifications }) => {
    const { t } = useTranslation();
    const [notifications, setNotifications] = useState([]);
    const [selectedNotifications, setSelectedNotifications] = useState([]);
    const [openFullScreen, setOpenFullScreen] = useState(false);
    const [openDetail, setOpenDetail] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const personalization = useRecoilValue(personalizationState);
    // const { data: notifications, error, isLoading } = useQuery(
    //     ['notifications'],
    //     fetchNotifications
    // );

    const notificationLabel = "CONTENT.NOTIFICATION.TITLE."
    const notificationDescLabel = "CONTENT.NOTIFICATION.DESCRIPTION."

    useEffect(() => {
        const fetchNotificationData = async () => {
            const response = await NotificationService.getNotifications(true)
            if (response.status) {
                setNotifications(response.data)
            }
        }
        fetchNotificationData();
    }, []);

    useEffect(() => {
        setSelectedNotifications((pre) => pre)
    }, [refresh]);

    const handleShowTitle = (title, isDescription) => {
        if (title.includes("|")) {
            const titleArray = title.split('|');
            let replacement = {}

            if (titleArray.length > 1) {
                for (let i = 1; i < titleArray.length; i++) {
                    const element = titleArray[i];
                    replacement[i - 1] = element
                }
            }
            return t((!isDescription ? notificationLabel : notificationDescLabel) + titleArray[0], replacement)

        }
        return t((!isDescription ? notificationLabel : notificationDescLabel) + title)
    }

    const handleOpenNotificationDetail = (item, setState) => {
        if (!item.read_status) {
            handleRead(item, true)
            if (item.id) {
                setState((pre) => {
                    let newNotifications = JSON.parse(JSON.stringify(pre))
                    newNotifications.forEach((notification) => {
                        if (notification.id === item.id) {
                            notification.read_status = 1
                        }
                    })
                    return newNotifications
                })
            }
        }
        setOpenDetail(item)
    }
    const handleCheckBox = (e, item) => {
        if (e.target.checked) {
            setSelectedNotifications((pre) => [...pre, item])
        }
        else if (!e.target.checked) {
            setSelectedNotifications((pre) => {
                const newSelected = pre.filter((notification) => notification.id !== item.id)
                return newSelected
            })
        }
    }

    const handleCheckedFound = (item) => {
        if (selectedNotifications.length, item) {
            const isOk = selectedNotifications.find((notification) => notification.id === item.id)
            if (isOk) {
                return true
            }
            return false
        }
        return false
    }

    const handleReadNotifications = async (items, setState, status) => {
        // if (items.id && items.read_status) {
        //     return
        // }
        const res = await handleRead(items, status)
        if (res.status) {
            if (items.id) {
                setState((pre) => {
                    let newNotifications = JSON.parse(JSON.stringify(pre))
                    newNotifications.forEach((notification) => {
                        if (notification.id === items.id) {
                            notification.read_status = status
                        }
                    })
                    return newNotifications
                })
            }
            else if (items.length) {
                setState((pre) => {
                    let newNotifications = JSON.parse(JSON.stringify(pre))
                    newNotifications.forEach((notification) => {
                        items.forEach(item => {
                            if (item.id === notification.id) {
                                notification.read_status = status
                            }
                        });
                    })
                    return newNotifications
                })
                setSelectedNotifications([])
            }
        }
    }

    const handleDelete = async (items, setState) => {
        const res = await handleDeleteNotifications(items)
        if (res.status) {
            if (items.id) {
                setState((pre) => {
                    let newNotifications = JSON.parse(JSON.stringify(pre))
                    newNotifications = newNotifications.filter((notification) => notification.id !== items.id)
                    return newNotifications
                })
            }
            else if (items.length) {
                setState((pre) => {
                    let newNotifications = JSON.parse(JSON.stringify(pre));
                    newNotifications = newNotifications.filter((notification) => {
                        // Use `some` to check if any item matches the notification ID
                        return !items.some(item => item.id === notification.id);
                    });
                    return newNotifications;
                });
                setSelectedNotifications([])
            }
        }
    }

    const handleSelectAll = (items) => {
        const selected = JSON.parse(JSON.stringify(items))
        setSelectedNotifications(selected)
    }

    const clearAll = (items) => {
        setSelectedNotifications([])
    }

    const detectSelectedNotifications = (setMethod) => {
        if (selectedNotifications.some(x => x.read_status)) { // unread
            return <div className='db-notification-header-read-container o-0-5' onClick={() => handleReadNotifications(selectedNotifications, setMethod, 0)}>
                <img className='db-notification-single-read-icon' src={UnreadIcon} />
                <span>{t(label + 'MARK-AS-UNREAD')}</span>

            </div>
        } else {
            return <div className='db-notification-header-read-container' onClick={() => handleReadNotifications(selectedNotifications, setMethod, 1)}>
                <img className='db-notification-single-read-icon' src={ReadIcon} />
                <span>{t(label + 'MARK-AS-READ')}</span>

            </div>
        }
    }

    return (
        <Popper open={open} anchorEl={anchorEl} style={{ marginTop: 10, minWidth: 500, minHeight: 150 }} transition placement='bottom-start'>
            {({ TransitionProps }) => (
                <ClickAwayListener onClickAway={handleClose}>
                    <Fade {...TransitionProps} timeout={350}>
                        <Paper className='db-notification-popper'>
                            <div className='db-notification-header-container'>
                                <div className="db-notification-label">{t(label + 'NOTIFICATIONS')}</div>
                                <Close className='db-notification-close-button' onClick={handleClose} />
                            </div>
                            <div className='db-notification-header-actions-container'>
                                {
                                    selectedNotifications?.length ?
                                        <span className='db-notification-select-all' onClick={clearAll}>{t(label + 'CLEAR-ALL')}</span>
                                        :
                                        <span className='db-notification-select-all' onClick={() => handleSelectAll(notifications)}>{t(label + 'SELECT-ALL')}</span>
                                }

                                {
                                    selectedNotifications.length ?
                                        <div className={`db-notification-header-actions`}>
                                            {detectSelectedNotifications(setNotifications)}
                                            <div className='db-notification-header-delete-container' onClick={() => handleDelete(selectedNotifications, setNotifications)}>
                                                <img className='db-notification-single-delete-icon' src={DeleteIcon} />
                                                <span>{t(label + 'DELETE')}</span>
                                            </div>
                                        </div> : undefined
                                }

                            </div>
                            <div className='db-notification-item-container'>
                                {notifications.map((item, itemI) => {
                                    const isChecked = handleCheckedFound(item)
                                    return (
                                        <div className={`db-notification-item ${item.read_status ? "db-readed-notification-item" : ""}`} key={itemI}>
                                            <div className='db-notification-title-container'>
                                                <div className='db-notification-title-and-checkbox'>
                                                    <CustomNotificationCheckbox checked={isChecked} className='db-notification-checkbox' onChange={(e) => handleCheckBox(e, item)} />
                                                    <div className={`db-seclabel ${item.read_status ? 'unread-notification-color' : ''}`} onClick={() => handleOpenNotificationDetail(item, setNotifications)}>
                                                        {handleShowTitle(item.title, false)}
                                                    </div>
                                                </div>
                                                <div className={`db-seclabel db-notification-date ${item.read_status ? 'unread-notification-color' : ''}`}>{convertToDateFormat(item.created_at, personalization.date_format)}</div>
                                            </div>
                                            <div className='db-notification-actions-container'>
                                                <Tooltip title={t(label + (item.read_status ? 'MARK-AS-UNREAD' : 'MARK-AS-READ'))} placement='top'>
                                                    <img className={`db-notification-single-read-icon ${item.read_status ? "o-0-5" : ""}`} src={item.read_status ? UnreadIcon : ReadIcon} onClick={() => handleReadNotifications(item, setNotifications, item.read_status ? 0 : 1)} />
                                                </Tooltip>
                                                <Tooltip title={t(label + 'DELETE')} placement='top'>
                                                    <img className='db-notification-single-delete-icon' src={DeleteIcon} onClick={() => handleDelete(item, setNotifications)} />
                                                </Tooltip>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                            <Button className='db-view-all-notifications-button' onClick={() => { setSelectedNotifications([]); setOpenFullScreen(true) }}>{t(label + 'VIEW-ALL-NOTIFICATIONS')}</Button>
                            {openFullScreen ?
                                <FullScreenNotifications handleClose={() => { setSelectedNotifications([]); setOpenFullScreen(false) }}
                                    label={label} handleShowTitle={handleShowTitle}
                                    handleOpenNotificationDetail={handleOpenNotificationDetail}
                                    handleCheckBox={handleCheckBox}
                                    handleRead={handleRead}
                                    selectedNotifications={selectedNotifications}
                                    handleCheckedFound={handleCheckedFound}
                                    setRefresh={setRefresh}
                                    handleReadNotifications={handleReadNotifications}
                                    handleDelete={handleDelete}
                                    handleSelectAll={handleSelectAll} clearAll={clearAll} detectSelectedNotifications={detectSelectedNotifications} />
                                : ""}
                            {openDetail ? <NotificationsDetail openDetail={openDetail} setOpenDetail={setOpenDetail} label={label} handleShowTitle={handleShowTitle} /> : ""}
                        </Paper>
                    </Fade>
                </ClickAwayListener>
            )
            }
        </Popper >
    )
}

export default DashBoardNotifications